import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Helpers
import { closeDrawer, getURLSegment, inIframe, launchVTC } from '../../helpers/helpers';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const StartVTC = observer(class StartVTC extends React.Component {
  componentWillMount() {
    const { ExamStore } = this.props.store;

    let accessCode = null;

    if(this.props.accessCode) {
      accessCode = this.props.accessCode;
    } else if(this.props.routing.location.pathname.indexOf('launch') >= 0) {
      accessCode = getURLSegment(this, 2);
    }

    if(accessCode && accessCode.indexOf('-') < 0) {
      accessCode = `${accessCode.slice(0, 3)}-${accessCode.slice(3, 6)}-${accessCode.slice(6)}`;
    }

    this.state = {
      accessCode,
      iframe: inIframe(),
      useProtocol: true
    }

    // Launch VTC session if we’re not in an iframe.
    // Otherwise, we’ll show a link to launch a new window.
    const launchFallback = () => this.setState({ useProtocol: false });

    if(!this.state.iframe) {
      launchVTC(this.state.accessCode, launchFallback);
    }

    // Check if session exists in store and get it if it doesn’t
    if(!ExamStore.examSession.status) {
      ExamStore.getExamSessionByAccessCode(accessCode)
    }
  }

  render() {
    const { store, translation } = this.props;
    const { ExamStore, SessionStore } = store;
    const { examSession } = ExamStore;

    if(!this.state.iframe && !SessionStore.loading && examSession.examConfiguration) {
      if(this.state.useProtocol) {
        return (
          <div className="panel panel--brief">
            <h2 className="panel__title">{translation.launching}</h2>

            <p>{translation.launching_body}</p>

            <button
              className="btn--link"
              onClick={() => this.setState({useProtocol: false})}
            >
              {translation.launch_fail}
            </button>
          </div>
        )
      } else {
        return (
          <div className="panel panel--brief">
            <h2 className="panel__title">{translation.heading}</h2>

            <p>{translation.body}</p>

            <span className="text-code">
              {this.state.accessCode}
            </span>

            <div className="block-list block-list__icons">
              <a
                className="block-list__block block--link title-link"
                href="http://virtual-test-center-builds.s3.amazonaws.com/production/SmarterProctoring-Installer.exe"
              >
                <icons.iconWindows />
                <span className="block-list__sub-title">{translation.windows}</span>
              </a>

              <a
                className="block-list__block block--link title-link"
                href="http://virtual-test-center-builds.s3.amazonaws.com/production/SmarterProctoring-Installer.dmg"
              >
                <icons.iconApple />
                <span className="block-list__sub-title">{translation.mac}</span>
              </a>
            </div>

            {!this.props.hideDashboard &&
              <Link to="/" onClick={(e) => {closeDrawer(e, this.props.parent, '/')}}>
                {translation.dashboard}
              </Link>
            }
          </div>
        )
      }
    } else if(this.state.iframe) {
      const header = document.querySelector('.site-head');

      if(header) {
        header.setAttribute('style', 'margin-bottom: 0; opacity: 0; visibility: hidden;');
      }

      return (
        <a
          className="btn btn--success btn--icn-right btn--lg btn--solo"
          href={`/#/launch/${this.state.accessCode}`}
          target="_blank"
        >
          {translation.launch_link}
          <icons.iconExternal />
        </a>
      )
    }

    return null
  }
})

export default translate('StartVTC')(StartVTC);


// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/StartVTC.js